
  const development = {
    endpointURL: {
      URL: process.env.REACT_APP_BASEURL_DEV,
    },
    websocketURL:process.env.REACT_APP_DEV_WEBSOCKET,
    uiEnv: "development",
    s3Bucket:process.env.REACT_APP_BUCKET_NAME_DEV,
    msal: {
      clientId: process.env.REACT_APP_AAD_APP_CLIENT_ID, // REACT_APP_AAD_APP_CLIENT_ID_DEV
      tenantId: process.env.REACT_APP_AAD_APP_TENANT_ID, // REACT_APP_AAD_APP_TENANT_ID_DEV
      scope: `api://${process.env.REACT_APP_AAD_APP_CLIENT_ID}/access_as_user`,
    },
  };
  
  const stage = {
    endpointURL: {
      URL: process.env.REACT_APP_BASEURL_STAGE,
    },
    websocketURL:process.env.REACT_APP_STG_WEBSOCKET,
    uiEnv: "stage",
    s3Bucket:process.env.REACT_APP_BUCKET_NAME_STAGE,
    msal: {
      clientId: process.env.REACT_APP_AAD_APP_CLIENT_ID, // REACT_APP_AAD_APP_CLIENT_ID_STAGE
      tenantId: process.env.REACT_APP_AAD_APP_TENANT_ID, // REACT_APP_AAD_APP_TENANT_ID_sTAG
      scope: `api://${process.env.REACT_APP_AAD_APP_CLIENT_ID}/access_as_user`,
    },
  };

  const prod = {
    endpointURL: {
      URL: process.env.REACT_APP_BASEURL_PROD,
    },
    websocketURL:process.env.REACT_APP_PROD_WEBSOCKET,
    uiEnv: "prod",
    s3Bucket:process.env.REACT_APP_BUCKET_NAME_PROD,
    msal: {
      clientId: process.env.REACT_APP_AAD_APP_PROD_CLIENT_ID, // REACT_APP_AAD_APP_CLIENT_ID_STAGE
      tenantId: process.env.REACT_APP_AAD_APP_PROD_TENANT_ID, // REACT_APP_AAD_APP_TENANT_ID_sTAGE
      scope: `api://${process.env.REACT_APP_AAD_APP_PROD_CLIENT_ID}/access_as_user`,
    },
  };
  
  const configEnvs = {
    development,
    stage,
    prod,
  };
  
  const config = {
    ...configEnvs[process.env.REACT_APP_CUSTOM_NODE_ENV],
  };
  
  export default config;
  